import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { type GetPayoutAccountsParams, getPayoutAccounts, sortPayoutAccountsByCreatedDesc } from '@/services/api/payout-accounts';

export const PAYOUT_ACCOUNTS_QUERY_KEY = ['funds', 'payout-accounts'] as const;

const UNBOUNDED_RANGE_KEY = 'unbounded';

export const payoutAccountsQueryOptions = (params: GetPayoutAccountsParams = {}) =>
  queryOptions({
    queryKey: [
      ...PAYOUT_ACCOUNTS_QUERY_KEY,
      params.accountHolderId ?? 'all',
      // Both-or-neither: a lone date never reaches the wire, so it must not fork the cache either
      params.fromDate && params.toDate ? `${params.fromDate.toISOString()}_${params.toDate.toISOString()}` : UNBOUNDED_RANGE_KEY,
    ],
    queryFn: () => getPayoutAccounts(params),
    select: sortPayoutAccountsByCreatedDesc,
    // A date-range change swaps the query key — keep the previous rows visible so the
    // "Update" refetch never blanks the table
    placeholderData: keepPreviousData,
  });

export const usePayoutAccounts = (params: GetPayoutAccountsParams = {}) => useQuery(payoutAccountsQueryOptions(params));
